export default class HeypsterFetch {
    constructor(apiKey, language='fr') {
        this.apiKey = apiKey;
        this.language = language;
        this.baseURL = 'https://heypster-gif.com/sdk';
    
        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'HEYPSTER-API-KEY': `${this.apiKey}`
        }
        this.currentPage = 1;
        this.currentTag = "";
        this.currentEmoji = "";
    }

    setApiKey(apiKey) {
        this.apiKey = apiKey;
    }

    setCurrentPage(pageNumber){
        if(isNaN(pageNumber)){
            throw new Error('Page number is not a number');
        }
        this.currentPage = pageNumber;
    }


    /*
     * Récupérer les gifs du jour
     */
    async getTrendingGifs() {
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }

        const url = `${this.baseURL}/gifs`;
        try {
            const response = await fetch(url, {
                headers: this.headers
            });

            if (!response.ok) {
                throw new Error('Network response error.');
            }

            const gifsData = await response.json();

            return gifsData;
        } catch (error) {
            throw new Error('Error fetching GIFs by string:', error);
        }
    }


    /*
        * Récupère les gifs via un tag passé en paramètre
        * @tag = id du tag cherché.
     */
    async getGifsForTag(tag) {
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }

        if(this.currentTag !== "" && this.currentTag !== tag){
            this.currentPage = 1;
            this.currentTag = tag;
        }

        const url = `${this.baseURL}/gifs-tags-v2/${tag}?page=${this.currentPage}`;

        try {
            const response = await fetch(url,{
                headers: this.headers
            });
            if (!response.ok) {
                throw new Error('Network response error.');
            }
            const gifsData = await response.json();
            this.currentPage++;

            return gifsData;

        } catch (error) {
            throw new Error('Error fetching GIFs:', error);
        }
    }


    /*
        * Récupère les gifs via un emoji passé en paramètre
        * @emoji = id de l'emoji cherché.
     */
    async getGifsForEmoji(emoji) {
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }

        if(this.currentEmoji !== "" && this.currentEmoji !== emoji){
            this.currentPage = 1;
            this.currentEmoji = emoji;
        }

        const url = `${this.baseURL}/gifs-emotions/${emoji}?page=${this.currentPage}`;

        try {
            const response = await fetch(url,{
                headers: this.headers
            });
            if (!response.ok) {
                throw new Error('Network response error.');
            }
            const gifsData = await response.json();
            this.currentPage++;

            return gifsData;

        } catch (error) {
            throw new Error('Error fetching GIFs:', error);
        }
    }

    async getTagsFromString(word){
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }


        const url = `${this.baseURL}/tags/${word}/${this.language}`;
        try {
            const response = await fetch(url,{ headers: this.headers });
            if (!response.ok) { throw new Error('Network response error.'); }
            const tags = await response.json();
            return tags;
        } catch (error) {
            throw new Error('Error fetching Tags:', error);
        }
    }

    /*
     * Trouver des GIFs via une chaîne de caractères
     * @searchTerm
     */
    async searchGifsByString(searchTerm, language) {
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }

        const url = `${this.baseURL}/gifs/${encodeURIComponent(searchTerm)}/${language}`;
        try {
            const response = await fetch(url, {
                headers: this.headers
            });

            if (!response.ok) {
                throw new Error('Network response error.');
            }

            const gifsData = await response.json();
            return gifsData;
        } catch (error) {
            throw new Error('Error fetching GIFs by string:', error);
        }
    }



    async loadNextPageGifs(next_page_url){
        if (!this.apiKey) {
            throw new Error('API key is required for this operation.');
        }
        const url = next_page_url.replace(/^http:\/\//, 'https://');

        try {
            const response = await fetch(url, {
                headers: this.headers
            });

            if (!response.ok) {
                throw new Error('Network response error.');
            }

            const gifsData = await response.json();
            return gifsData;
        } catch (error) {
            throw new Error('Error fetching GIFs by string:', error);
        }
    }


}